import { ModalComponent } from "cruzo/ui-components/modal";
import { appScope } from "site/api";

export type OwnerPaymentCancelModalContext = {
  paymentId: number;
  status: string;
  bookTitle: string;
  tinkoffId: string;
};

let context: OwnerPaymentCancelModalContext | null = null;

export function openOwnerPaymentCancelModal(next: OwnerPaymentCancelModalContext): void {
  context = next;
  ModalComponent.attach("ownerPaymentCancelModal", appScope.id);
}

export function getOwnerPaymentCancelModalContext(): OwnerPaymentCancelModalContext | null {
  return context;
}

export function clearOwnerPaymentCancelModalContext(): void {
  context = null;
}
